import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import chapterExampleImage from 'assets/all-repetition.svg'
import sectionExampleImage from 'assets/session-repetition.svg'

import { QUIZ_DIAGNOSTICS_RESPONSIVE_MAX_WIDTH } from '../utils/quizDiagnosticsBreakpoints'

type QuizDiagnosticsExampleLegendProps = {
  variant: 'chapter' | 'section'
}

const EXAMPLE_CARD_WIDTH = 277

const QuizDiagnosticsExampleLegend = ({
  variant
}: QuizDiagnosticsExampleLegendProps): JSX.Element => {
  const { t } = useTranslation()
  const isChapterVariant = variant === 'chapter'

  return (
    <ExampleCard>
      <ExampleImage
        src={isChapterVariant ? chapterExampleImage : sectionExampleImage}
        alt={t(
          isChapterVariant
            ? 'quizDiagnostics.exampleLegend.chapterAlt'
            : 'quizDiagnostics.exampleLegend.sectionAlt'
        )}
        draggable={false}
      />
    </ExampleCard>
  )
}

export default QuizDiagnosticsExampleLegend

export { EXAMPLE_CARD_WIDTH }

const ExampleCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${EXAMPLE_CARD_WIDTH}px;
  min-width: ${EXAMPLE_CARD_WIDTH}px;
  max-width: ${EXAMPLE_CARD_WIDTH}px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #cdcdcd;
  background: #ececec;
  box-shadow: 0px 4px 12px 0px #0000001a;
  pointer-events: none;
  user-select: none;
  overflow: hidden;

  @media (max-width: ${QUIZ_DIAGNOSTICS_RESPONSIVE_MAX_WIDTH}px) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
`

const ExampleImage = styled.img`
  display: block;
  width: 254px;
  height: 121px;
  max-width: 100%;
  pointer-events: none;
  user-select: none;
  object-fit: contain;
  object-position: center center;
`
